import { CLARITY_PROJECT_ID, GA_MEASUREMENT_ID, GTM_CONTAINER_ID } from './config.js';

/**
 * Appends an async script once, resolving when it has loaded.
 *
 * @param {string} src
 * @returns {Promise<void>}
 */
function loadScript(src) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();

            return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;

        document.head.appendChild(script);
    });
}

export async function loadGoogleAnalytics() {
    try {
        await loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`);

        window.gtag('js', new Date());
        window.gtag('config', GA_MEASUREMENT_ID);
    } catch (error) {
        console.error('Failed to load Google Analytics', error);
    }
}

export function loadGoogleTagManager() {
    if (window.__gtmLoaded) {
        return;
    }

    window.__gtmLoaded = true;
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

    loadScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`).catch((error) => {
        console.error('Failed to load Google Tag Manager', error);
    });
}

export function loadClarity() {
    if (window.clarity) {
        return;
    }

    // Clarity's queue stores `arguments` objects, so this cannot be an arrow function.
    window.clarity = function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
    };

    loadScript(`https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`).catch((error) => {
        console.error('Failed to load Clarity', error);
    });
}
